import axios from 'axios'

const headers = {}
headers.Authorization = 'Basic U3RldmVuIENoYXBtYW46S2xvcDA='
headers['content-type'] = 'application/json'
headers.resolveWithFullResponse = true

const {
  VUE_APP_API_SERVER,
  VUE_APP_DOMINO_BASE
} = process.env

const SRVgetSearchResults = async searchterm => {
  try { 
    const strHost = VUE_APP_API_SERVER + '/websitesearch/'
      const data = await axios
    .get(`${strHost}${searchterm}`, headers)
    if(data?.data){
      return data.data
    }else return []
  }catch(err){
    return err
  }
}

const SRVgetAllSearchResults = async key => {
  try {
  const iMax = 6
  const rnd = Math.random() * 100
  let strCount = '&rnd=' + rnd

  if (iMax > 0) { strCount = '&count=' + iMax + strCount }
  let favURL = '/gsearch.nsf/api/data/collections/name/searchLookup?keys='
  favURL = VUE_APP_DOMINO_BASE + favURL + key + strCount
  
  const data = await axios.get(favURL, headers)
    if(data?.data?.length) return data.data
    else return []
  }catch(err){
    return err
  }
}

export {
  SRVgetSearchResults,
  SRVgetAllSearchResults
}
